import { competenciesByStyle } from "../../../../utils/competency-catalog";

/**
 * Tabla de estilos DISC con las competencias asociadas a cada uno.
 *
 * Es la referencia de qué se va a evaluar en modo por patrón, así que se 
 * muestra como panel de ancho completo.
 *
 * Sin props: los datos salen del catálogo, que es la fuente única. Cuando #69
 * reasigne colores, la tabla lo refleja sin tocar este archivo.
 */
const DiscStyleTable = () => {
  const styles = competenciesByStyle();
  const competenciesPerStyle = styles[0]?.competencies.length ?? 0;

  return (
    <div className="gm-disc-style-table">
      <div className="gm-disc-style-table-head">
        <span>ESTILO</span>
        <span>COMPETENCIAS ASOCIADAS ({competenciesPerStyle})</span>
      </div>

      {styles.map(({ colorCode, styleName, colorLabel, color, backgroundColor, badgeTextColor, competencies }) => (
        <div
          key={colorCode}
          className="gm-disc-style-row"
          data-testid={`disc-style-row-${colorCode}`}
        >
          <div className="gm-disc-style-name">
            <span className="gm-disc-style-dot" style={{ backgroundColor: color }} />
            <strong>{styleName}</strong>
            <span className="gm-disc-style-color-label">{colorLabel}</span>
          </div>

          <ul className="gm-disc-style-badges">
            {competencies.map(({ key, label }) => (
              <li
                key={key}
                // La `key` y no el label: hay nombres de competencia que se
                // repiten como "elemento que evalúa" de otra, y necesitamos un
                // identificador único en el DOM.
                data-testid={`disc-style-badge-${key}`}
                style={{ backgroundColor, color: badgeTextColor }}
              >
                {label}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default DiscStyleTable;
